import { render, staticRenderFns } from "./ErrorDBC.vue?vue&type=template&id=a11fed7c&scoped=true"
import script from "./ErrorDBC.vue?vue&type=script&lang=js"
export * from "./ErrorDBC.vue?vue&type=script&lang=js"
import style0 from "./ErrorDBC.vue?vue&type=style&index=0&id=a11fed7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11fed7c",
  null
  
)

export default component.exports